import PropTypes from 'prop-types';
import React from 'react';
import ExpandIcon from '../ExpandIcon';

const AccordionHeader = ({ onClick, expanded, headerText }) => (
  <div className="accordion-header" onClick={onClick}>
    <span className="accordion-header__text">{headerText}</span>
    <ExpandIcon expanded={expanded} />
  </div>
);

AccordionHeader.propTypes = {
  onClick: PropTypes.func.isRequired,
  expanded: PropTypes.bool.isRequired,
  headerText: PropTypes.string.isRequired
};

export default AccordionHeader;
